import React from "react";
import {cn} from "../../utils/cn";

/**
 * Low-level input. Use TextField for the labeled version.
 */
const Input = React.forwardRef(function Input(
  {className, hasError = false, leadingIcon: Lead, trailingIcon: Trail, ...props},
  ref
) {
  if (!Lead && !Trail) {
    return (
      <input
        ref={ref}
        className={cn(
          "block w-full h-9 px-3 text-base rounded-md",
          "bg-white border border-ink-200 shadow-inset",
          "text-ink-900 placeholder:text-ink-400",
          "transition-colors duration-fast",
          "hover:border-ink-300",
          "focus:border-brand-500 focus:outline-none focus:ring focus:ring-offset-0",
          "disabled:bg-ink-50 disabled:text-ink-400 disabled:cursor-not-allowed",
          hasError && "border-danger-500 focus:border-danger-500 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.25)]",
          className
        )}
        {...props}
      />
    );
  }
  return (
    <div className="relative">
      {Lead && (
        <Lead className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-400 pointer-events-none" aria-hidden="true" />
      )}
      <input
        ref={ref}
        className={cn(
          "block w-full h-9 text-base rounded-md",
          "bg-white border border-ink-200 shadow-inset",
          "text-ink-900 placeholder:text-ink-400",
          "transition-colors duration-fast",
          "hover:border-ink-300",
          "focus:border-brand-500 focus:outline-none focus:ring focus:ring-offset-0",
          "disabled:bg-ink-50 disabled:text-ink-400 disabled:cursor-not-allowed",
          Lead ? "pl-9" : "pl-3",
          Trail ? "pr-9" : "pr-3",
          hasError && "border-danger-500 focus:border-danger-500 focus:shadow-[0_0_0_3px_rgba(239,68,68,0.25)]",
          className
        )}
        {...props}
      />
      {Trail && (
        <Trail className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-400" aria-hidden="true" />
      )}
    </div>
  );
});

export default Input;
